import { useEffect } from "react";
import { api } from "@/lib/api";

export default function StoreTheme() {
  useEffect(() => {
    api.get("/themes/storefront").then((response) => {
      const theme = response.data;
      if (!theme?.content) return;
      const style = document.createElement("style");
      style.dataset.storeTheme = theme.id;
      style.textContent = theme.format === "css" ? theme.content : `.store{${Object.entries(JSON.parse(theme.content)).map(([key, value]) => `--${key}:${value};`).join("")}}`;
      document.head.appendChild(style);
      return () => style.remove();
    }).catch(() => {});
  }, []);
  return null;
}